import React, { useEffect, useState, useRef } from "react";
import useSiteData from '../../useSiteData'
import { Desktop, MEDIUM, Mobile } from "../util/breakpoints";
import Logo from "../molecules/Logo";
import Link from "../atoms/Link";
import useMediaQuery from '../util/useMediaQuery'

export default ({ locationName, locationMeta, locationPriceFrom, currency, productCode, bookingsAvailable, campNotAvailable }) => {
    if(!productCode) return null; // do not display booking bar on locact pages without product code
    const [sticky, setSticky] = useState(false);
    const element = useRef(null);
    const isMediumDown = useMediaQuery({ maxWidth: MEDIUM - 1 });
    const { translations } = useSiteData().pageSettings;
    const slug = useSiteData().checkoutSlug;
    const link = { internalLink: { slug }, anchor: { anchorName: productCode.toUpperCase() } };

    const showFromPrice = false


    const notAvailableMessage = campNotAvailable ? campNotAvailable : (( translations && translations.campNotAvailable) ? translations.campNotAvailable : 'Unfortunately there are no bookable dates on this camp right now. Check out our other camps instead!' )

    useEffect(() => {
        if (!element || !element.current) return;

        document.querySelector("body").classList.add('u-fixed-elements');

        const elementHeight = element.current.clientHeight;

        const onScroll = () => {
            if (!element || !element.current) return;

            const { bottom } = element.current.getBoundingClientRect();
            const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            const scrollPosTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollPosTop <= elementHeight) {
                setSticky(false);
            } else if (bottom <= windowHeight && !sticky) {
                setSticky(true);
            }
        };

        document.addEventListener("scroll", onScroll);
        return () => {
            document.removeEventListener("scroll", onScroll);
            document.querySelector("body").classList.remove('u-fixed-elements');
        };
    }, []);

    return (
        <section className={ "o-booking" + (sticky || isMediumDown ? " o-booking--sticky" : "") } ref={ element }>
            <Desktop>
                <div className="o-booking__row u-container">
                    <div className="o-booking__content">
                        <Logo isRed/>
                        { showFromPrice && <>
                            { bookingsAvailable && <p className="o-booking__info">{ locationName }</p> }
                            { bookingsAvailable && <p className="o-booking__meta">{ locationMeta }</p> }
                        </> }

                        { !showFromPrice && bookingsAvailable && <p className="o-booking__info">{ locationName }</p> }
                    </div>
                    <div className="o-booking__content">
                        { showFromPrice && bookingsAvailable && <>
                            <p className="o-booking__info">{ translations.from } { currency } { locationPriceFrom } /  { translations.person }</p>
                            <Link className="a-btn a-btn--red" link={ link }>
                                { (translations.book ? translations.book : "Book") }
                            </Link>
                        </> }
                        { !showFromPrice && bookingsAvailable && 
                            <Link className="a-btn a-btn--red" link={ link }>
                                { (translations.book ? translations.book : "Book") }
                            </Link>
                        }

                        { !bookingsAvailable && <p className="o-booking__meta" dangerouslySetInnerHTML={{ __html: notAvailableMessage }} /> }
                    </div>
                </div>
            </Desktop>
            <Mobile>
                <div className="o-booking__row u-container">
                    <div className="o-booking__content">
                        { bookingsAvailable && showFromPrice && <p className="o-booking__info">{ translations.from } { currency } { locationPriceFrom } /  { translations.person }</p> }
                        { bookingsAvailable && showFromPrice && <p className="o-booking__meta">{ locationName } - { locationMeta }</p> }
                        { bookingsAvailable && !showFromPrice && <p className="o-booking__meta o-booking__meta--large">{ locationName }</p> }
                    </div>
                    <div className="o-booking__content">
                        { bookingsAvailable && <Link className="a-btn a-btn--red" link={ link }>
                            { (translations.book ? translations.book : "Book") }
                        </Link> }
                        { !bookingsAvailable && <p className="o-booking__meta" dangerouslySetInnerHTML={{ __html: notAvailableMessage }} /> }
                    </div>
                </div>
            </Mobile>
        </section>
    );
}
